import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { Column } from 'react-table'
import { BaseTable, IColumn } from 'src/components/BaseTable'
import { useConfigTable } from 'src/hooks/useConfigTable'
import { tableStore } from 'src/stores/TableStore'
import { resourceTabela } from 'src/utils/resourcesTabela'
import { AddRecord, Paper, TableContainer } from '../../components'
import NoResultsTable from '../../components/NoResultsTable'
import Spacer from '../../components/Spacer'
import { CidadeColumns } from './CidadesColumns'
import { cidadesStore } from './stores'
import { CidadesDetail } from './types'

interface Props {
  onDelete: (id: string) => void
  checks?: {
    ids: string[]
    onCheck: (id: string) => void
  }
  authorization?: {
    canCreate: boolean
    canDelete: boolean
    canUpdate: boolean
  }
}

export const CidadesTable = observer(({ onDelete, authorization }: Props) => {
  const { pathname } = useLocation()

  const KEY_TABLE = resourceTabela.CIDADES
  useConfigTable(KEY_TABLE)
  const tableState = tableStore.getState(KEY_TABLE)
  const isTableReady =
    !cidadesStore.cidades.isLoading &&
    tableState &&
    cidadesStore.cidades.list.length

  const columns: Array<Column & IColumn> = useMemo(
    () => CidadeColumns({ onDelete, authorization }),
    [onDelete, authorization]
  )

  const rows = cidadesStore.cidades.list.map(
    ({ ...cidades }: CidadesDetail) => {
      return {
        ...cidades,
        estado: cidades.Estado.nome
      }
    }
  )

  const sortMapper = new Map([['estado', 'Estado.nome']])

  return (
    <>
      <Spacer y={4} />
      <Paper>
        <TableContainer
          loading={cidadesStore.cidades.isLoading}
          totalCount={cidadesStore.cidades.totalCount}
        >
          {isTableReady ? (
            <BaseTable
              keyTable={KEY_TABLE}
              columns={columns}
              hasConditionClickRow={false}
              linkWithRedirectClickRow={pathname}
              data={rows}
              sortMapper={sortMapper}
            />
          ) : (
            <NoResultsTable loading={cidadesStore.cidades.isLoading} />
          )}
        </TableContainer>
      </Paper>
      <AddRecord path={pathname} authorization={authorization} />
    </>
  )
})
